import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;

  h1 {
    text-align: left;
    margin: 0;
    color: #1a1a1a;
    font-size: 24px;
  }

  .header-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    margin-bottom: 25px;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 30px 0 15px 0;
    display: flex;
    align-items: center;
    gap: 10px;

    &::after {
      content: "";
      flex: 1;
      height: 1px;
      background: #f0f0f0;
    }
  }

  .main-tags {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 350px));
    gap: 15px;
    margin-bottom: 30px;
  }

  .tag-item {
    padding: 20px 25px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: #fff;
    color: #333;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;

    .tag-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .value {
      font-size: 26px;
      color: #1a1a1a;
      font-weight: 800;
      margin-top: 5px;
    }

    &.highlight {
      border-left: 4px solid #008037;
      .value {
        color: #008037;
      }
    }
  }

  /* Estilo de Listagem igual ao Leads */
  .payments-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .payment-card {
    background: #fff;
    padding: 15px 25px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: 2fr 1.5fr 1.5fr 1fr;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(5px);
    }

    @media (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      flex-direction: column;
      strong {
        font-size: 15px;
        color: #333;
      }
      span {
        font-size: 12px;
        color: #999;
      }
    }

    .value-info {
      font-size: 16px;
      font-weight: bold;
      color: #008037;
      text-align: right;
      padding-right: 20px;
    }

    .date-info {
      font-size: 13px;
      color: #888;
      display: flex;
      flex-direction: column;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
      }
    }
  }

  .status-badge {
    padding: 5px 12px;
    border-radius: 50px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: fit-content;
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }
`;
